import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

function LinkError({ linkError, contactSupport, chatWithUs }) {
  const handleOpenChat = () => {
    window.zE?.('webWidget', 'show')
    window.zE?.('webWidget', 'open')
  }

  return (
    <div className="download-files-modal__error">
      <p className="download-files-modal__error-text cgt-body-md">{linkError}</p>
      <p className="download-files-modal__error-text cgt-body-md">{contactSupport}</p>
      <Button type="secondary" size="medium" actionType="button" onClick={handleOpenChat}>
        {chatWithUs}
      </Button>
    </div>
  )
}

LinkError.propTypes = {
  linkError: string.isRequired,
  contactSupport: string.isRequired,
  chatWithUs: string.isRequired,
}

export default LinkError
